import { render, staticRenderFns } from "./RadioBoxInput.vue?vue&type=template&id=ebc3648a&scoped=true"
import script from "./RadioBoxInput.vue?vue&type=script&lang=js"
export * from "./RadioBoxInput.vue?vue&type=script&lang=js"
import style0 from "./RadioBoxInput.vue?vue&type=style&index=0&id=ebc3648a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc3648a",
  null
  
)

export default component.exports